import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
export const NAMESPACE = "accessLevelsCreatorPanel";
export const FULL_NAMESPACE = createNamespace(NAMESPACE);
